import { SketchPicker } from 'react-color';

import PopoverButton from 'components/Popover/PopoverButton';

import styles from './ColorPicker.styles.scss';

const ColorPicker = ({ className, style, label, color, setColor, fullWidth, center, disabled }) => {
  const propsStyles = {
    style: {
      ...(fullWidth ? { width: '100%' } : {}),
      ...(center ? { justifyContent: 'center' } : {}),
      ...style
    }
  };

  return (
    <PopoverButton
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      transformOrigin={{ vertical: 'top', horizontal: 'center' }}
      button={
        <button {...propsStyles} disabled={disabled} className={`${styles.container} ${className}`}>
          <div
            style={{ backgroundColor: color, border: `solid thin ${color === '#ffffff' ? '#eeeeee' : 'white'}` }}
            className={styles.color}
          />
          <div className={styles.labels}>
            <span className={styles.labelName}>{label}</span>
            <span className={styles.colorName}>{color}</span>
          </div>
        </button>
      }
    >
      <SketchPicker color={color} onChangeComplete={color => setColor(color.hex)} disableAlpha={true} />
    </PopoverButton>
  );
};

export default ColorPicker;

ColorPicker.defaultProps = {
  label: 'Color'
};
